import type { EventItem } from '../types/events';

export const pastEvents: EventItem[] = [
  {
    id: 'independencia-2026',
    date: '2026-09-15',
    title: 'Día de la Independencia Hondureña',
    subtitle: 'Honduran Independence Day',
    location: 'MacArthur Park, Los Angeles',
    tag: 'Cultural',
    description:
      'A proud celebration of Honduran independence with flag ceremonies, traditional food, music, and community pride.',
    attended: '500+',
    image: 'https://cdn.magicpatterns.com/uploads/79rtRidmreAtMb7Kg2Q2cS/IMG_0558.jpg',
    imageAlt: 'Community members holding a giant Honduran flag in the street during the Independence Day parade',
  },
  {
    id: 'parrillada-2026',
    date: '2026-07-16',
    title: 'Parrillada en Familia',
    subtitle: 'Family BBQ',
    location: 'Griffith Park, Los Angeles',
    tag: 'Community',
    description:
      'A beloved annual family BBQ bringing together hundreds of Honduran families for a day of food, games, and community.',
    attended: '300+',
  },
];

export const events: EventItem[] = [
  {
    id: 'noche-hondurena',
    date: '2026-10-12',
    time: '6:00 PM – 11:00 PM',
    title: 'Noche Hondureña en LA',
    subtitle: 'Honduran Night in LA',
    location: 'East Los Angeles Community Center',
    tag: 'Cultural',
    price: 'Free / Gratis',
    description:
      'An unforgettable evening of Honduran music, food, dance, and culture. Join us as we celebrate our roots and bring the community together.',
    descriptionEs:
      'Una noche inolvidable de música, comida, baile y cultura hondureña. Únete a nosotros para celebrar nuestras raíces.',
    ctaLabel: 'Register / Registrarse',
  },
  {
    id: 'business-mixer',
    date: '2026-10-24',
    time: '6:30 PM – 9:00 PM',
    title: 'Honduran Business Mixer',
    location: 'Downtown Los Angeles',
    tag: 'Business',
  },
  {
    id: 'feria-negocios',
    date: '2026-11-03',
    time: '10:00 AM – 5:00 PM',
    title: 'Feria de Negocios Hondureños',
    subtitle: 'Honduran Business Fair',
    location: 'Downtown Los Angeles Convention Area',
    tag: 'Business',
    price: '$10',
    description:
      'Connect with Honduran entrepreneurs, discover local businesses, and explore opportunities for collaboration and growth in the LA market.',
    ctaLabel: 'Register / Registrarse',
  },
  {
    id: 'youth-workshop',
    date: '2026-11-08',
    time: '10:00 AM – 1:00 PM',
    title: 'Youth Heritage Workshop',
    location: 'Van Nuys',
    tag: 'Youth',
  },
  {
    id: 'festival-garifuna',
    date: '2026-11-19',
    time: '12:00 PM – 8:00 PM',
    title: 'Festival de Garifuna',
    subtitle: 'Garifuna Festival',
    location: 'Boyle Heights Cultural Park',
    tag: 'Cultural',
    price: 'Free / Gratis',
    description:
      'Celebrate the vibrant Garifuna culture with traditional drumming, dance, food, and storytelling. A day of pride and community.',
    ctaLabel: 'Register / Registrarse',
  },
  {
    id: 'volunteer-day',
    date: '2026-11-22',
    time: '9:00 AM – 12:00 PM',
    title: 'Community Volunteer Day',
    location: 'South L.A.',
    tag: 'Community',
  },
  {
    id: 'posada-hondurena',
    date: '2026-12-14',
    time: '5:00 PM – 10:00 PM',
    title: 'Posada Hondureña 2026',
    subtitle: 'Honduran Posada 2026',
    location: 'Koreatown Community Hall',
    tag: 'Cultural',
    price: '$5',
    description:
      'Ring in the holiday season with traditional Honduran posada celebrations, tamales, music, and family fun for all ages.',
    ctaLabel: 'Register / Registrarse',
  },
  {
    id: 'baleada-fest',
    date: '2027-01-17',
    time: '11:00 AM – 4:00 PM',
    title: 'Baleada Fest & Makers Market',
    location: 'The Valley',
    tag: 'Business',
  },
];
